module.exports = __webpack_public_path__ + "static/media/logo_clinica_del_ginocchio.80c2ddfd.png";